import { DetailsStep } from "./DetailsStep";
import { PricesStep } from "./Prices";
import { UsersStep } from "./Users";

export const stepsConfig = [
  { title: "Details", component: DetailsStep },
  { title: "Prices", component: PricesStep },
  { title: "Users", component: UsersStep },
];
